import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'caret-up-down', 'CaretUpDown', [["path",{"d":"M18 10l-6 -6l-6 6h12"}],["path",{"d":"M18 14l-6 6l-6 -6h12"}]]);